const ADD_MODE = {
  LIST: 'list',
  DEFAULT: 'add',
  APPLICATIONS: 'applications',
  PAYMENTS: 'payments',
  LEASES: 'leases',
  INTENT_SELECTION: 'intentSelection',
};

const UPDATE_ALL = 'UPDATE_ALL';

const BEHAVIOR_OPTIONS = {
  ADD: 'Add',
  EDIT: 'Edit',
  ARCHIVE: 'Archive',
  ARCHIVE_OR_DELETE: 'Archive or delete',
} as const;

const EMPTY_LISTING = {
  address: '',
  isRoomForRent: '',
  numUnits: '',
  propertyType: '',
  unit: '',
  listingAlias: '',
  customerId: '',
};

const EMPTY_ERROR = {
  address: '',
  propertyType: '',
  unit: '',
  numUnits: '',
  customerId: '',
};

const NUMBER_OF_UNITS_ERROR = 'Number of units must be a whole number.';
const POSITIVE_NUMBER_OF_UNITS_ERROR = 'Number of units must be greater than 0.';
const MAX_NUM_UNITS_VALUE = 20000;
const MAX_NUM_UNITS_ERROR = `Number of units must be less than or equal to ${MAX_NUM_UNITS_VALUE}.`;

const MAX_NUM_MULTIPLEX_UNITS_VALUE = 24;
const MAX_NUM_MULTIPLEX_UNITS_ERROR = `Number of units must be less than or equal to ${MAX_NUM_MULTIPLEX_UNITS_VALUE}.`;

const AddPropertyConstants = {
  ADD_MODE,
  BEHAVIOR_OPTIONS,
  EMPTY_ERROR,
  EMPTY_LISTING,
  MAX_NUM_UNITS_ERROR,
  MAX_NUM_UNITS_VALUE,
  MAX_NUM_MULTIPLEX_UNITS_ERROR,
  MAX_NUM_MULTIPLEX_UNITS_VALUE,
  NUMBER_OF_UNITS_ERROR,
  POSITIVE_NUMBER_OF_UNITS_ERROR,
  UPDATE_ALL,
} as const;

export default AddPropertyConstants;
